<template>
  <Modal
    title="Resposta Agravo"
    :active.sync="popupActivo"
    @close="cancelModal"
  >
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formAgravoResposta.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Resposta</span>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-help-circle"
            v-model="formAgravoResposta.resposta"
            id="resposta"
            name="resposta"
            v-validate="'required'"
            :state="validateState(veeFields, veeErrors, 'resposta')"
            :class="validateStateClass(veeFields, veeErrors, 'resposta')"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Negar Proposta</span>
          <vs-switch
            color="success"
            v-model="formAgravoResposta.negarProposta"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div v-if="!formAgravoResposta.negarProposta" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Porcentagem</span>
          <vs-input
            class="w-full"
            type="number"
            step="0.01"
            icon-pack="feather"
            icon="icon-percent"
            v-model="formAgravoResposta.porcentagem"
            id="Porcentagem"
            name="Porcentagem"
            v-validate="{ required: true, min_value: -100, max_value: 100 }"
            :state="validateState(veeFields, veeErrors, 'Porcentagem')"
            :class="validateStateClass(veeFields, veeErrors, 'Porcentagem')"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>ID Prince API</span>
          <vs-input
            type="number"
            step="1"
            class="w-full"
            icon-pack="feather"
            icon="icon-chevrons-right"
            v-model="formAgravoResposta.integrations.prince.id"
            id="id-prince-api"
            name="id-prince-api"
            v-validate="'required|min_value:1'"
            :state="validateState(veeFields, veeErrors, 'id-prince-api')"
            :class="validateStateClass(veeFields, veeErrors, 'id-prince-api')"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>ID Resposta I4Pro</span>
          <vs-input
            type="number"
            step="1"
            class="w-full"
            icon-pack="feather"
            icon="icon-chevrons-right"
            v-model="formAgravoResposta.integrations.i4pro.id"
            id="id-answer-i4pro"
            name="id-answer-i4pro"
            :state="validateState(veeFields, veeErrors, 'id-answer-i4pro')"
            :class="validateStateClass(veeFields, veeErrors, 'id-answer-i4pro')"
          />
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="cancelModal"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="resposta.idRespostaAgravo == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div></form
  ></Modal>
</template>
<script>
import BotaoSubmit from '../../../../components/BotaoSubmit.vue';
import ErrorsAlert from '../../../../components/ErrorsAlert.vue';
import Modal from '../../../../components/Modal.vue';

import services from '../../../../services';
import utilsList from '../../../../utils/list';
import notify from '../../../../utils/notify';

export default {
  name: 'popup-agravo-resposta',
  components: {
    BotaoSubmit,
    ErrorsAlert,
    Modal
  },
  data() {
    return {
      popupActivo: false,
      aguardeCadastro: false,
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      formAgravoResposta: {
        idRespostaAgravo: null,
        idAgravo: null,
        status: false,
        resposta: null,
        porcentagem: null,
        negarProposta: false,
        integrations: {
          prince: {
            id: null,
          },
          i4pro: {
            id: null,
          },
        },
      },
      resposta: {},
    };
  },
  watch: {},
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  methods: {
    open(resposta) {
      if (resposta) {
        this.resposta = resposta;
        this.preencheForm();
      }

      this.popupActivo = true;
    },
    preencheForm() {
      this.formAgravoResposta.idRespostaAgravo = this.resposta.idRespostaAgravo;
      this.formAgravoResposta.idAgravo = this.resposta.idAgravo;
      this.formAgravoResposta.status = this.resposta.deletedAt ? false : true;
      this.formAgravoResposta.resposta = this.resposta.resposta;
      this.formAgravoResposta.porcentagem = this.resposta.porcentagem;
      this.formAgravoResposta.negarProposta = this.resposta.negarProposta
        ? this.resposta.negarProposta
        : false;

      if (this.resposta.integrations) {
        const integrations = JSON.parse(this.resposta.integrations);
        let i4proId = null;
        if (integrations.i4pro) {
          if (integrations.i4pro.id !== undefined && integrations.i4pro.id !== null) {
            i4proId = integrations.i4pro.id;
          } else if (
            integrations.i4pro.answerId !== undefined &&
            integrations.i4pro.answerId !== null
          ) {
            i4proId = integrations.i4pro.answerId;
          }
        }
        this.formAgravoResposta.integrations = {
          ...this.formAgravoResposta.integrations,
          ...integrations,
          i4pro: {
            id: i4proId,
          },
        };
      }
    },
    resetForm() {
      this.formAgravoResposta = {
        idRespostaAgravo: null,
        idAgravo: null,
        status: false,
        resposta: null,
        porcentagem: null,
        negarProposta: false,
        integrations: {
          prince: {
            id: null,
          },
          i4pro: {
            id: null,
          },
        },
      };
    },
    async onSubmit() {
      const validated = await this.$validator.validateAll();
      if (!validated) {
        return;
      }

      if (
        this.formAgravoResposta.negarProposta &&
        !this.formAgravoResposta.porcentagem
      ) {
        this.formAgravoResposta.porcentagem = 0;
      }

      this.formAgravoResposta.integrations = JSON.stringify(
        this.formAgravoResposta.integrations,
      );

      try {
        this.$vs.loading();
        await services.post(
          'agravos',
          'agravos-resposta',
          this.formAgravoResposta,
        );

        this.formAgravoResposta.integrations = JSON.parse(
          this.formAgravoResposta.integrations,
        );

        notify.notifySuccess(this.$vs, 'Operação realizada com sucesso!');

        this.closeModal();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    closeModal() {
      this.resetForm();
      this.popupActivo = false;
      this.$emit('close', true);
    },
    cancelModal() {
      this.resetForm();
      this.popupActivo = false;
      this.$emit('close', false);
    },
  },
};
</script>
<style></style>
